import { createStructuredSelector } from 'reselect'

import {
   REQUEST_LIST,
   REQUEST_LIST_SUCCESS, 
   REQUEST_LIST_ERROR,
   REQUEST_PAGE_SET,
   REQUEST_SEARCH_SET,
   REQUEST_SEARCH_CHANGE,
   REQUEST_SEARCH_DELIVERY_ORDER_LINE_LOT,
   REQUEST_SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS,
   REQUEST_SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR, 
   REQUEST_ADD_SET,
   REQUEST_ADD_MODAL_SET,
   REQUEST_ADD,
   REQUEST_ADD_SUCCESS,
   REQUEST_ADD_ERROR,
   REQUEST_ADD_CHANGE,
   REQUEST_DETAIL,
   REQUEST_DETAIL_SUCCESS,
   REQUEST_DETAIL_ERROR,
   REQUEST_VIEW_MODAL_SET,
   REQUEST_EDIT_CHANGE,
   REQUEST_EDIT_MODAL_SET,
   REQUEST_UPDATE,
   REQUEST_UPDATE_SUCCESS,
   REQUEST_UPDATE_ERROR,
   REQUEST_VIEW_TAB_SET,
   REQUEST_UPLOAD_SET,
   REQUEST_UPLOAD_SET_SUCCESS,
   REQUEST_UPLOAD_SET_ERROR,
   REQUEST_UPLOAD_RESET
} from '../actions';

export const REQUEST_NAME = 'request';
const NAME = REQUEST_NAME;

export const RequestList = (page, num_page, orderBy, filters, stateFilter, display) => ({
  type:  REQUEST_LIST,
  payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter, display: display }
});

export const RequestListSuccess = (data) => ({
  type:  REQUEST_LIST_SUCCESS,
  payload: data
});

export const RequestListError = (error) => ({
  type:  REQUEST_LIST_ERROR,
  payload: error
});

export const RequestPageSet = (data) => ({
  type:  REQUEST_PAGE_SET,
  payload: data
});

export const RequestSearchSet = (data) => ({
  type:  REQUEST_SEARCH_SET,
  payload: data
});

export const RequestSearchChangeSet = (data) => ({
  type:  REQUEST_SEARCH_CHANGE,
  payload: data
});

export const RequestSearchDeliveryOrderLineLot = (data) => ({
  type:  REQUEST_SEARCH_DELIVERY_ORDER_LINE_LOT,
  payload: data
});

export const RequestSearchDeliveryOrderLineLotSuccess = (message) => ({
  type:  REQUEST_SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS,
  payload: message
});

export const RequestSearchDeliveryOrderLineLotError = (error) => ({
  type:  REQUEST_SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR,
  payload: error
}); 

export const RequestAddChangeSet = (data) => ({
  type:  REQUEST_ADD_CHANGE,
  payload: data
});

export const RequestAddSet = (data) => ({
  type:  REQUEST_ADD_SET,
  payload: data
});

export const RequestAddModalSet = (data) => ({
  type:  REQUEST_ADD_MODAL_SET,
  payload: data
});

export const RequestAdd = (data) => ({
  type:  REQUEST_ADD,
  payload: data
});

export const RequestAddSuccess = (message) => ({
  type:  REQUEST_ADD_SUCCESS,
  payload: message
});

export const RequestAddError = (error) => ({
  type:  REQUEST_ADD_ERROR,
  payload: error
});

export const RequestDetail = (data) => ({
  type:  REQUEST_DETAIL,
  payload: data
});

export const RequestDetailSuccess = (data) => ({
  type:  REQUEST_DETAIL_SUCCESS,
  payload: data
});

export const RequestDetailError = (error) => ({
  type:  REQUEST_DETAIL_ERROR,
  payload: error
});

export const RequestViewModalSet = (data) => ({
  type:  REQUEST_VIEW_MODAL_SET,
  payload: data
});

export const RequestEditModalSet = (data) => ({
  type:  REQUEST_EDIT_MODAL_SET,
  payload: data
});

export const RequestEditChangeSet = (data) => ({
  type:  REQUEST_EDIT_CHANGE,
  payload: data
});

export const RequestUpdate = (data) => ({
  type:  REQUEST_UPDATE,
  payload: data
});

export const RequestUpdateSuccess = (message) => ({
  type:  REQUEST_UPDATE_SUCCESS,
  payload: message.message
});

export const RequestUpdateError = (error) => ({
  type:  REQUEST_UPDATE_ERROR,
  payload: error
});

export const RequestViewTabSet = (data) => ({
  type:  REQUEST_VIEW_TAB_SET,
  payload: data
});

export const RequestUploadSet = (file) => ({
  type:  REQUEST_UPLOAD_SET,
  payload: { file },
});

export const RequestUploadSetSuccess = (items) => ({
  type:  REQUEST_UPLOAD_SET_SUCCESS,
  payload: items,
});

export const RequestUploadSetError = (error) => ({
  type:  REQUEST_UPLOAD_SET_ERROR,
  payload: error,
});

export const RequestUploadReset= () => ({
  type:  REQUEST_UPLOAD_RESET
});

const request = (state) => state[NAME];

export const RequestSelector = createStructuredSelector({
  request
})
 